export default __webpack_public_path__ + "static/media/zanib.8779457d.png";